import React from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import ImageInfo from './image_info.jsx';

import md5 from 'js-md5';

const styles = theme => ({
    root: {
        width: '100%',
    },
    image: {
        backgroundSize: 'contain',
        objectFit: 'contain',
        width: null,
        height: 350,
        paddingTop: 15,
        backgroundColor: 'black'

    }
});

class Image extends React.Component {
    state = {
        image: {},
        loading: true,
    };

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/image/${this.props.match.params.id}`)
            .then(res => {
                const image = res.data;

                this.setState({ image, loading: false })
            })
    }

    render() {
        const { classes  } = this.props;
        const { image } = this.state;


        let hash = (image && image.job_uuid) ? md5(image.job_uuid) : null;
        let url = `https://cdn.deeplearn.lol//home/ben/tmp-deeplearn/0-${hash}.png`;

        return (
            <div className={classes.root}>
                <Typography variant="headline" gutterBottom>{image && image.fields && image.fields.title}</Typography>
                <Grid container className={classes.gridContainer} spacing={16}>
                    <Grid item lg={6} md={12}>
                        {hash && (
                            <img className={classes.image} src={url} />
                        )}
                    </Grid>
                    <Grid item lg={6} md={12}>
                        <ImageInfo image={image} />
                    </Grid>
                </Grid>
                <Grid container className={classes.gridContainer} spacing={16}>
                    <Grid item xs={12}>
                    </Grid>
                </Grid>

            </div>
        );
    }
}


export default withStyles(styles)(Image);



// WEBPACK FOOTER //
// ./src/components/image.jsx